module.exports = __webpack_public_path__ + "img/5.552d1cd.jpg";